import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRouter } from '@tanstack/react-router';
import { api, endpoints } from '../api';

export const authStateQueryKey = ['auth-state'] as const;

export function useAuth(redirectUrl = '/') {
  const router = useRouter();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (password: string) => {
      await api.post(endpoints.auth.login, {
        password,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: authStateQueryKey });
      router.history.push(redirectUrl);
    },
  });
}
